import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({
  theme: "light",
  toggleTheme: () => {},
  setTheme: () => {},
});

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try {
      const stored = localStorage.getItem("driplee_theme");
      if (stored === "night" || stored === "dark") return "night";
    } catch {}
    return "light";
  });

  useEffect(() => {
    const root = window.document.documentElement;
    const isNight = theme === "night";
    
    if (isNight) {
      root.classList.add("night-shift", "dark");
    } else {
      root.classList.remove("night-shift", "dark");
    }

    // Dynamically update theme-color meta for seamless iOS and Android status bars
    try {
      const themeColorMeta = window.document.querySelector('meta[name="theme-color"]');
      if (themeColorMeta) {
        themeColorMeta.setAttribute("content", isNight ? "#09141B" : "#D9EAF2");
      }
    } catch (err) {
      console.error("Failed to update theme-color meta tag:", err);
    }

    try {
      localStorage.setItem("driplee_theme", theme);
    } catch {}
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "night" : "light"));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
